



































import { ListAnimationMixin } from '../mixins/list-animation.mixin';
import PaginationBar from './crud/pagination-bar.component.vue';
import { UiProgressLinear } from './keen-ui';

export default {
  name: 'results-grid',
  components: {
    PaginationBar,
    UiProgressLinear
  },
  mixins: [ListAnimationMixin],
  props: {
    results: {
      type: Array,
      default: () => []
    },
    itemsPerRow: {
      type: Number,
      default: 4
    },
    pagination: Object,
    lastPageDisabled: Boolean,
    loading: Boolean
  },
  computed: {
    itemStyle: function () {
      return {
        flexBasis: `calc((100% - ${ this.itemMargin * 2 * this.itemsPerRow }px) / ${ this.itemsPerRow })`,
        margin: `${ this.itemMargin }px`
      };
    }
  },
  data: function () {
    return {
      hoveredResultId: undefined,
      defaultResultImageUrl: require('../assets/media/image/image-not-found.svg'),
      itemMargin: 10
    };
  },
  methods: {
    getResultImageUrl: function (result): string {
      return (result.imageUrl || this.defaultResultImageUrl);
    },
    onResultImageError: function (event): void {
      event.target.src = this.defaultResultImageUrl;
    }
  }
};
